/**
 * Helpers for SEO-friendly URLs in the pattern `/{slug}-{id}`.
 *
 * The frontend never constructs the id itself — it passes the compound string
 * straight to the backend, which extracts the trailing id via HasSlugIdRouting.
 * These helpers only exist to (a) build URLs from models and (b) defensively
 * parse a slugId param when a page needs the raw id (rare).
 */

export function parseSlugId(slugId: string): number | null {
  const last = slugId.split('-').pop();
  if (!last) return null;
  const n = Number(last);
  return Number.isInteger(n) && n > 0 ? n : null;
}

type HasSlugAndId = { slug: string; id: number };

export const carUrl = (c: HasSlugAndId): string => `/cars/${c.slug}-${c.id}`;

export const garageCarUrl = (c: HasSlugAndId): string => `/garage/${c.slug}-${c.id}`;

export const eventUrl = (e: HasSlugAndId): string => `/events/${e.slug}-${e.id}`;

export const bazaarItemUrl = (b: HasSlugAndId): string => `/bazaar/${b.slug}-${b.id}`;

export const forumThreadUrl = (t: HasSlugAndId): string => `/forum/threads/${t.slug}-${t.id}`;
